"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../lib/messages"));
const utils_1 = require("../../lib/utils");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const video_component_1 = __importDefault(require("./video-component"));
const youtube_video_component_1 = __importDefault(require("./youtube-video-component"));
const provider_video_styles_1 = require("./provider-video.styles");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderVideo = ({ intl, provider }) => {
    const { video_url } = provider;
    const videoComponentProps = {
        url: video_url,
        accessibilityText: intl.formatMessage(messages_1.default.ariavideo),
        iframeId: 'main-provider-video',
        containerClass: 'video-wrapper'
    };
    return (react_1.default.createElement(provider_video_styles_1.VideoWrapper, null,
        react_1.default.createElement(card_container_1.default, null,
            react_1.default.createElement(provider_video_styles_1.VideoSectionHeader, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.videoHeader))),
            (0, utils_1.isUrlYouTube)(video_url) ? (react_1.default.createElement(youtube_video_component_1.default, Object.assign({}, videoComponentProps))) : (react_1.default.createElement(video_component_1.default, Object.assign({}, videoComponentProps))))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(ProviderVideo));
//# sourceMappingURL=provider-video.js.map